import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import MiniLegend from "../../../../items/MiniLegend";
import Source from "../../../../items/Source";

import {BarChart} from "d3plus-react";

import {calculateDomain} from "../../../../../helpers/formatters";


class LaborMarketDemand extends Component {

  render() {
    const {clustersData, selectedCluster} = this.props;

    const selectedClusterID = selectedCluster.id;
    const averageClusterID = 14;
    const clustersIds = [selectedClusterID, averageClusterID];

    const filteredData = clustersData.filter(cd => clustersIds.indexOf(cd.cluster_id) > -1);

    const colors = filteredData.map(d => ({color: d.color, label: d.cluster_name}));

    // share of EU startups?? no data..
    // share of EU high tech?? no data..
    const fields = {
      'employment_share_in_knowledge_intensive_services_2018_in_share': '<b>Knowledge intensive services</b>',
      'employment_share_in_non_techincal_services_2018_in_share': '<b>Non-technical services</b>',
      'employment_share_in_public_sector_and_healthcare_2018_in_share': '<b>Public sector & healthcare</b>',
      'employment_share_in_construction_2018_in_share': '<b>Construction</b>',
      'employment_share_in_industry_2018_in_share': '<b>Manufacturing</b>',
      'employment_share_in_agriculture_2018_in_share': '<b>Agriculture</b>'
    };

    const finalData = [];
    let xMax = 0;
    let xMin = 0;
    let value;
    Object.keys(fields).forEach(f => {
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({cluster_id: fd.cluster_id, cluster_name: fd.cluster_name, property: fields[f], value: value, color: fd.color});
        xMax = xMax < value ? value : xMax;
        xMin = xMin > value ? value : xMin;
      });
    });

    const chartConfig = {
      data: finalData,
      detectVisible: true,
      groupBy: "cluster_name",
      height: 450,
      legend:false,
      discrete: "y",
      y: "property",
      x: "value",
      tooltipConfig: {
        body: d => `<div>${d.property} employment share: ${(d.value * 100).toFixed(1)}%</div>`
      },
      yConfig: {
        title: false,
        minSize: 150,
      },
      xConfig: {
        // labels: [0, Math.floor(xMax)],
        title: false,
        tickFormat: x => `${Math.round(x*100)}%`,
        domain: calculateDomain(xMin, xMax)
      },
      shapeConfig: {
        fill: d => d.color,
        label: d => false,
        duration: 0,
        Bar: {
          height: 20,
          label: (d) => (`${(d.value * 100).toFixed(1)}%`)
        }
      },
      groupPadding: 25,
      barPadding: 2,
      legendTooltip: {
        body: "",
        footer: "",
      },
      on: {"click.legend": () => {}}
    };
    return (
      <CarouselItem title="Labor demands" subtitle={<><b>Employment share by sector,</b> 2018, %</>}>
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <BarChart config={chartConfig} />
          <Source text="Source: Oxford Economics, Eurostat; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : [],
    selectedCluster: state.settings.map["Clusters"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborMarketDemand);
